import { useFeliz_React__React_useState_Static_1505 } from "./fable_modules/Feliz.1.68.0/React.fs.js";
import { createElement } from "react";
import { collect as collect_1, sort, singleton as singleton_1, head, isEmpty, filter, map as map_1, mapIndexed, tail, ofArray } from "./fable_modules/fable-library.3.7.20/List.js";
import { Interop_reactApi } from "./fable_modules/Feliz.1.68.0/./Interop.fs.js";
import { create, match } from "./fable_modules/fable-library.3.7.20/RegExp.js";
import { empty, collect, singleton, append, map, delay, toList } from "./fable_modules/fable-library.3.7.20/Seq.js";
import { tryFind, ofList } from "./fable_modules/fable-library.3.7.20/Map.js";
import { spells } from "./Spells.fs.js";
import { comparePrimitives, stringHash, createObj, equals } from "./fable_modules/fable-library.3.7.20/Util.js";
import { split, join } from "./fable_modules/fable-library.3.7.20/String.js";
import { List_distinct } from "./fable_modules/fable-library.3.7.20/Seq2.js";
import { value as value_23 } from "./fable_modules/fable-library.3.7.20/Option.js";

export function Counter() {
    const patternInput = useFeliz_React__React_useState_Static_1505(0);
    const count = patternInput[0] | 0;
    const children = ofArray([createElement("h1", {
        children: [count],
    }), createElement("button", {
        onClick: (_arg) => {
            patternInput[1](count + 1);
        },
        children: "Increment",
    })]);
    return createElement("div", {
        children: Interop_reactApi.Children.toArray(Array.from(children)),
    });
}

export function Regex_$007CParseRegex$007C_$007C(regex, str) {
    const m = match(create(regex), str);
    if (m != null) {
        return tail(toList(delay(() => map((x) => (x || ""), m))));
    }
    else {
        return void 0;
    }
}

export function Tup2_create(x, y) {
    return [x, y];
}

export function List_number(lst) {
    return mapIndexed((ix, v) => [v, ix], lst);
}

export function Html_class$0027(className, ctor, children) {
    return ctor(ofArray([["children", Interop_reactApi.Children.toArray(Array.from(children))], ["className", className]]));
}

export function Html_classTxt(className, ctor, txt) {
    return ctor(ofArray([["children", txt], ["className", className]]));
}

export const spellLookup = ofList(map_1((s) => [s.name, s], spells));

export function Spell(spellInputProps) {
    const magicType = spellInputProps.magicType;
    const spell = spellInputProps.spell;
    const byMagicType = filter((p) => {
        if (equals(magicType, void 0)) {
            return true;
        }
        else {
            return equals(magicType, p.heading);
        }
    }, spell.prereqs);
    const isTopLevel = magicType == null;
    const patternInput = useFeliz_React__React_useState_Static_1505(isTopLevel ? (void 0) : ((!isEmpty(byMagicType)) ? ((!isEmpty(head(byMagicType).items)) ? (isEmpty(tail(head(byMagicType).items)) ? (isEmpty(tail(byMagicType)) ? [0, 0] : (void 0)) : (void 0)) : (void 0)) : (void 0)));
    const update = patternInput[1];
    const children = toList(delay(() => append(singleton(createElement("div", {
        className: "spellHeader",
        children: `${spell.name} (${spell.college})`,
    })), delay(() => collect((matchValue) => {
        const pix = matchValue[1] | 0;
        const p_1 = matchValue[0];
        return collect((matchValue_1) => {
            const cix = matchValue_1[1] | 0;
            const chain = matchValue_1[0];
            const prereqs = join(" and ", chain);
            const isSelected = equals(patternInput[0], [pix, cix]);
            const toggle = (_arg) => {
                if (!isSelected) {
                    update([pix, cix]);
                }
                else {
                    update(void 0);
                }
            };
            return singleton(Html_class$0027("prereqs", (arg) => createElement("div", createObj(arg)), toList(delay(() => append(singleton(createElement("input", {
                type: "checkbox",
                checked: isSelected,
                readOnly: true,
                onClick: toggle,
            })), delay(() => {
                const descr = isTopLevel ? (`${p_1.heading}: ${prereqs}`) : prereqs;
                return append(singleton(createElement("label", {
                    children: descr,
                    className: "label",
                    onClick: toggle,
                })), delay(() => (isSelected ? collect((prereqName) => {
                    const matchValue_2 = tryFind(prereqName, spellLookup);
                    if (matchValue_2 == null) {
                        let pattern_matching_result, preamble, spellName;
                        const activePatternResult = Regex_$007CParseRegex$007C_$007C("(.*) including (.*)", prereqName);
                        if (activePatternResult != null) {
                            if (!isEmpty(activePatternResult)) {
                                if (!isEmpty(tail(activePatternResult))) {
                                    if (isEmpty(tail(tail(activePatternResult)))) {
                                        pattern_matching_result = 0;
                                        preamble = head(activePatternResult);
                                        spellName = head(tail(activePatternResult));
                                    }
                                    else {
                                        pattern_matching_result = 1;
                                    }
                                }
                                else {
                                    pattern_matching_result = 1;
                                }
                            }
                            else {
                                pattern_matching_result = 1;
                            }
                        }
                        else {
                            pattern_matching_result = 1;
                        }
                        switch (pattern_matching_result) {
                            case 0: {
                                return append(singleton(Html_class$0027("drilldown", (arg_2) => createElement("div", createObj(arg_2)), singleton_1(createElement("div", {
                                    className: "spellHeader",
                                    children: preamble,
                                })))), delay(() => {
                                    const matchValue_4 = tryFind(spellName, spellLookup);
                                    if (matchValue_4 != null) {
                                        const spell_2 = matchValue_4;
                                        return singleton(Html_class$0027("drilldown", (arg_3) => createElement("div", createObj(arg_3)), singleton_1(createElement(Spell, {
                                            spell: spell_2,
                                            magicType: p_1.heading,
                                        }))));
                                    }
                                    else {
                                        throw (new Error(`shouldn't happen ${spellName}`));
                                        return empty();
                                    }
                                }));
                            }
                            case 1: {
                                return singleton(Html_class$0027("drilldown", (arg_4) => createElement("div", createObj(arg_4)), singleton_1(createElement("div", {
                                    className: "spellHeader",
                                    children: prereqName,
                                }))));
                            }
                        }
                    }
                    else {
                        const spell_1 = matchValue_2;
                        return singleton(Html_class$0027("drilldown", (arg_1) => createElement("div", createObj(arg_1)), singleton_1(createElement(Spell, {
                            spell: spell_1,
                            magicType: p_1.heading,
                        }))));
                    }
                }, chain) : empty())));
            }))))));
        }, List_number(p_1.items));
    }, List_number(byMagicType))))));
    return createElement("div", {
        children: Interop_reactApi.Children.toArray(Array.from(children)),
    });
}

export const colleges = sort(List_distinct(collect_1((spell) => ofArray(split(spell.college, ["/"], null, 0)), spells), {
    Equals: (x, y) => (x === y),
    GetHashCode: stringHash,
}), {
    Compare: comparePrimitives,
});

export function debounce(ms, f) {
    let threadId = void 0;
    return (v) => {
        if (threadId != null) {
            window.clearTimeout(value_23(threadId));
        }
        threadId = window.setTimeout((_arg) => {
            f(v);
            threadId = (void 0);
        }, ms);
    };
}

export function class$0027(classname, ctor, children) {
    return ctor(ofArray([["className", classname], ["children", Interop_reactApi.Children.toArray(Array.from(children))]]));
}

export function Spells() {
    let value_1, elems;
    const patternInput = useFeliz_React__React_useState_Static_1505("");
    const updateNameFilter = patternInput[1];
    const nameFilter = patternInput[0];
    const allCollege = "All colleges";
    const patternInput_1 = useFeliz_React__React_useState_Static_1505(allCollege);
    const updateCollegeFilter = patternInput_1[1];
    const collegeFilter = patternInput_1[0];
    const nameInput = debounce(100, updateNameFilter);
    const children = ofArray([class$0027("stickyHeader", (arg) => createElement("div", createObj(arg)), [createElement("legend", {
        children: ["Search:"],
    }), createElement("input", createObj(ofArray([(value_1 = nameFilter, ["ref", (e) => {
        if ((!(e == null)) && (!equals(e.value, value_1))) {
            e.value = value_1;
        }
    }]), ["autoFocus", true], ["onChange", (ev) => {
        nameInput(ev.target.value);
    }]]))), createElement("select", createObj(ofArray([["id", "collegeFilter"], ["onChange", (ev_1) => {
        updateCollegeFilter(ev_1.target.value);
    }], (elems = toList(delay(() => append(singleton(createElement("option", {
        children: [allCollege],
    })), delay(() => map((c) => createElement("option", {
        children: [c],
    }), colleges))))), ["children", Interop_reactApi.Children.toArray(Array.from(elems))]), ["value", collegeFilter]]))), createElement("button", {
        children: "Clear",
        onClick: (_arg) => {
            updateCollegeFilter(allCollege);
            updateNameFilter("");
            nameInput("");
        },
    })]), class$0027("body", (arg_1) => createElement("div", createObj(arg_1)), toList(delay(() => append(singleton(createElement("h1", {
        children: ["Spells"],
    })), delay(() => {
        const nameFilter_1 = nameFilter.toLowerCase().trim();
        const collegeFilter_1 = collegeFilter.toLowerCase().trim();
        return collect((spell) => ((((nameFilter_1 === "") ? true : (spell.name.toLowerCase().indexOf(nameFilter_1) >= 0)) && ((collegeFilter_1 === "all colleges") ? true : (spell.college.toLowerCase().indexOf(collegeFilter_1) >= 0))) ? singleton(createElement(Spell, {
            spell: spell,
            magicType: void 0,
        })) : empty()), spells);
    })))))]);
    return createElement("div", {
        children: Interop_reactApi.Children.toArray(Array.from(children)),
    });
}

//# sourceMappingURL=Components.fs.js.map
